import { create } from 'zustand';

import { IContextState, IInitialState } from './interfaces';

const initialState: IInitialState = {
  isActive: true,
  isGlowing: false,
};

export const useVirtualAssistantContext = create<IContextState>((set) => ({
  ...initialState,
  setIsActive: (isActive) => set({ isActive }),
  setIsGlowing: (isGlowing) => set({ isGlowing }),
}));
